
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns7cdc4300070878ab3039036beebf6165en from './en.yaml'
            i18n.addResourceBundle('en', '7cdc4300070878ab3039036beebf6165', flattenObject(ns7cdc4300070878ab3039036beebf6165en), true, true);
        
        export default '7cdc4300070878ab3039036beebf6165';
    